import HoldOn from 'react-hold-on'
import { fxRateSuccess } from '../../Reducer/FX_Rate_Reducer';
import axios from 'axios';
import apiUrl from '../../ApiUrl';

export const FxRateAPI = (body) => async (dispatch) => {
    let options = {
        theme: 'sk-cube-grid',
        message: 'Rate Converter ...',
    }
    try {
        HoldOn.open(options);
        const formattedBody = { ...body, destination_amount: Number(body?.destination_amount) }
        const response = await axios.post(`${apiUrl}fx/fetch/rate`, formattedBody)
        console.log("Response of fx rate api:- ", response.data)
        if (response.data) {
            dispatch(fxRateSuccess(response.data))
        }
        return response.data;

    }
    catch (error) {
        console.error("Error in fx rate api:- ", error)
    }
    finally {
        HoldOn.close();
    }
}